import { api } from './client'

// FR-27: Report schedules
export const listSchedules  = (pid)          => api.get(`/reports/programs/${pid}/schedules`).then(r => r.data)
export const createSchedule = (pid, body)    => api.post(`/reports/programs/${pid}/schedules`, body).then(r => r.data)
export const toggleSchedule = (pid, id, is_active) =>
  api.patch(`/reports/programs/${pid}/schedules/${id}`, { is_active }).then(r => r.data)
export const deleteSchedule = (pid, id)      => api.delete(`/reports/programs/${pid}/schedules/${id}`).then(r => r.data)
